import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "web-design-system";
import NotFoundPage from "@core/components/layout/app404";
import { routeTree } from "./routeTree.gen";
import "./styles/tokens.css";
import { initApp } from "./init";
import { useTheme } from "./theme";

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    allowedAccess?: boolean;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false },
  },
});

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultNotFoundComponent: NotFoundPage,
  context: { queryClient } as const,
  Wrap: ({ children }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  ),
});

initApp({
  onUnauthorisedRequest: async () => {
    const isAuthRoute = router.state.matches.some((match) =>
      match.routeId.startsWith("/(auth)")
    );
    if (!isAuthRoute) return;
    queryClient.clear();
    router.navigate({ to: "/login/distributor", replace: true });
  },
});

function App() {
  const { theme } = useTheme();
  return (
    <div className="App">
      <RouterProvider router={router} />
      <Toaster theme={theme} className="![--width:25rem] pointer-events-auto" />
    </div>
  );
}

export default App;
